import { useNavigate, useParams } from 'react-router-dom';
import style from './BlogPostItem.module.css';
import { useMemo } from 'react';

const slugify = (s = '') =>
  s
    .toLowerCase()
    .normalize('NFKD') // прибираємо діакритику
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-') // все зайве -> "-"
    .replace(/^-+|-+$/g, '') // обрізаємо краї
    .slice(0, 80); // обмежуємо довжину

const BlogPostItem = ({ info, handleDelete }) => {
  const { lang = 'en' } = useParams();
  const navigate = useNavigate();

  const title = useMemo(
    () => info.titles.find(el => el.language === lang)?.title,
    [lang, info],
  );

  const desc = useMemo(
    () =>
      info.metaDescriptions.find(el => el.language === lang)?.metaDescription,
    [lang, info],
  );

  const img = info.imageUrl;

  // робимо красивий слаг з тайтла; якщо тайтла нема — підставимо 'post'
  const slug = useMemo(() => slugify(title || '') || 'post', [title]);

  // новий формат: /lang/blog/post/:slug/:id
  const to = `/${lang || 'en'}/blog/post/${slug}/${info._id}`;

  return (
    <div className={style.gradientContainer}>
      <article className={style.projectItem}>
        <h1>{title}</h1>

        {img ? (
          <div className={style.imgContainer}>
            <img src={img} alt={title} loading="lazy" />
          </div>
        ) : null}

        <div className={style.descriptionContainer}>
          <p>{desc}</p>
        </div>

        <button
          type="button"
          className={style.website}
          onClick={() => navigate(to)}
        >
          Read more
        </button>

        <button
          type="button"
          className={style.deleteBtn}
          onClick={handleDelete} // або onClick={() => handleDelete(info._id)}
        >
          Delete
        </button>
      </article>
    </div>
  );
};

export default BlogPostItem;
